import { Grid } from "@chakra-ui/react";
import React from "react";
import {
  OptionContentComponent,
  LoadingOptionItem,
  EmptyOptionItem,
  NoSearchOptionItem,
  OptionRow,
} from "./OptionItem";
import { AnySelectOption } from "./SelectOption";

export type SelectorListProps<TOption extends AnySelectOption> = {
  options: TOption[];
  sortedOptions: TOption[];
  selectedValueSet: Set<TOption["value"]>;
  activeValue?: TOption["value"];
  isLoading?: boolean;
  enableDoubleColumn: boolean;
  wrapText: boolean;
  containerRef: React.RefObject<HTMLDivElement>;
  onFocus: React.FocusEventHandler<HTMLDivElement>;
  onKeyDown: React.KeyboardEventHandler<HTMLDivElement>;
  onSelect: (value: TOption["value"]) => void;
  OptionContent: OptionContentComponent<TOption>;
};

export function SelectorList<TOption extends AnySelectOption>({
  options,
  sortedOptions,
  selectedValueSet,
  activeValue,
  isLoading,
  enableDoubleColumn,
  wrapText,
  containerRef,
  onFocus,
  onKeyDown,
  onSelect,
  OptionContent,
}: SelectorListProps<TOption>) {
  return (
    <Grid
      ref={containerRef}
      minW={0}
      width="full"
      overflowY="auto"
      autoRows="max-content"
      templateColumns={enableDoubleColumn ? "repeat(2, 1fr)" : "1fr"}
      tabIndex={-1}
      role="listbox"
      onFocus={onFocus}
      onKeyDown={onKeyDown}
    >
      {isLoading && sortedOptions.length === 0 && <LoadingOptionItem />}

      {!isLoading && options.length === 0 && <EmptyOptionItem />}

      {!isLoading && options.length > 0 && sortedOptions.length === 0 && (
        <NoSearchOptionItem />
      )}

      {!isLoading &&
        sortedOptions.map((option) => (
          <OptionRow
            key={option.value}
            option={option}
            isSelected={selectedValueSet.has(option.value)}
            onSelect={onSelect}
            borderBottomWidth="1px"
            borderRightWidth={enableDoubleColumn ? "1px" : 0}
            tabIndex={option.value === activeValue ? 0 : -1}
            data-option-value={option.value}
            OptionContent={OptionContent}
            wrapText={wrapText}
          />
        ))}
    </Grid>
  );
}
